import React from 'react';
import './LoadingHelper.css'; // Assuming you have some basic CSS for the spinner

const LoadingHelper = () => (
  <div className="loading-overlay">
    <div className="spinner"></div> {/* Simple CSS spinner */}
  </div>
);

export default LoadingHelper;
